"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GTAG_JS_ORIGIN_FILENAME = exports.GTAG_JS_ACCI_FILENAME = exports.DATA_TEST_IDS = exports.MESSAGE_ON_LOAD_IDS = exports.MESSAGE_ON_LOAD_URL_PARAM = exports.AUTH_TOKEN_EXPIRATION_DAYS = exports.AUTH_TOKEN_CREATOR_KEY = exports.AUTH_TOKEN_KEY = void 0;
exports.AUTH_TOKEN_KEY = 'acci_jwt';
exports.AUTH_TOKEN_CREATOR_KEY = 'acci_jwt_creator';
exports.AUTH_TOKEN_EXPIRATION_DAYS = 7;
exports.MESSAGE_ON_LOAD_URL_PARAM = 'acci_message_id';
exports.MESSAGE_ON_LOAD_IDS = {
    errorForceReload: '128',
};
/**
 * Test IDs used for E2E testing with Playwright.
 * These IDs are added to HTML elements using the `data-test-id` attribute.
 *
 * @remarks
 * This file must stay in sync with `shared/acci-utils/src/tracking/constants.ts`.
 * When adding or modifying test IDs, update both files.
 *
 * Note that the legacy and modern packages cannot share dependencies, this is why we duplicate the
 * constant.
 */
var DATA_TEST_IDS;
(function (DATA_TEST_IDS) {
    DATA_TEST_IDS["homeHero"] = "homeHero";
    DATA_TEST_IDS["homeHeroTitle"] = "homeHeroTitle";
    DATA_TEST_IDS["cookieConsentAcceptAll"] = "cookieConsentAcceptAll";
})(DATA_TEST_IDS = exports.DATA_TEST_IDS || (exports.DATA_TEST_IDS = {}));
// We use `.js` instead of `/js` since Cloudflare caches urls with file extension by default
exports.GTAG_JS_ACCI_FILENAME = 'RdIsiPJ0.js';
exports.GTAG_JS_ORIGIN_FILENAME = 'gtag/js';
//# sourceMappingURL=constants.js.map